import React from 'react';
import './index.css';

type ScoreWithScaleProps = {
    className?: string;
    score: number;
    scoreMin: number;
    scoreMax: number;
    fontSize?: number;
};

function ScoreWithScale2({
    className,
    score,
    scoreMin,
    scoreMax,
    fontSize = 50
}: ScoreWithScaleProps) {
    return (
        <div className={`scoreWithScale2 ${className}`}>
            <p
                className='scoreWithScale2__score'
                style={{
                    fontSize: fontSize,
                    lineHeight: 0.8
                }}
            >
                {score}
            </p>
            <p className='scoreWithScale2__scale'>
                {scoreMin} to<br/>
                {scoreMax}
            </p>
        </div>
    );
}

export default ScoreWithScale2;